var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firi-cont"},[_c('div',{staticClass:"firi-color",style:('background-color:' + _vm.color)}),_c('div',{staticClass:"firi-label",style:('border-color:' + _vm.color)},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }